import { type AccountId, accountIdFormat } from "@redotech/redo-account-id";
import { freightDeliveryAccessorialPresetIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

const FreightDeliveryAccessorialPresetRowSchema_ = z.object({
  id: freightDeliveryAccessorialPresetIdFormat.schema,
  accountId: accountIdFormat.schema,
  name: z.string(),
  liftgateRequired: z.boolean(),
  insideDelivery: z.boolean(),
  appointmentRequired: z.boolean(),
  instructions: z.string().nullish(),
  isDefault: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const FreightDeliveryAccessorialPresetRowSchema: z.ZodType<FreightDeliveryAccessorialPresetRow> =
  FreightDeliveryAccessorialPresetRowSchema_;
export interface FreightDeliveryAccessorialPresetRow extends z.infer<
  typeof FreightDeliveryAccessorialPresetRowSchema_
> {}

export interface CreateFreightDeliveryAccessorialPresetInput {
  accountId: AccountId;
  name: string;
  liftgateRequired: boolean;
  insideDelivery: boolean;
  appointmentRequired: boolean;
  instructions?: string | null;
  isDefault?: boolean;
}
